<template v-else>
    <div v-if="chatStore.notFound||(chatStore.isLoadedUser && chatStore.isLoadedProduct && chatStore.cardsUser.length === 0 && chatStore.cardsProduct.length === 0)" class="alert">
        پیامی برای شما وجود ندارد
    </div>
    <div :class="['chat-wrapper',chatStore.notFound||(chatStore.isLoadedUser && chatStore.isLoadedProduct && chatStore.cardsUser.length === 0 && chatStore.cardsProduct.length === 0)?'hide':'']">
        <div :class="[chatStore.cardsUser.length === 0?'hide':'',showOne && userId >0 ? 'show-one-user' : (!showOne?'all-users':'users')]">
            <AllChatUser/>
        </div>
        <div :class="[chatStore.cardsProduct.length === 0?'hide':'',showOne && productId >0 ? 'show-one-product' : (!showOne?'all-products':'products')]">
            <AllChatProduct/>
        </div>
        <div :class="showOne ? 'show-one-chat' : 'chats'">
            <AllChatList :one="showOne"/>
        </div>
    </div>
</template>
<script setup>
    import { computed, defineProps, ref } from 'vue'
    import AllChatUser from '@/components/dashboard/bodys/chat/all/AllChatUser.vue'
    import AllChatProduct from '@/components/dashboard/bodys/chat/all/AllChatProduct.vue'
    import AllChatList from '@/components/dashboard/bodys/chat/all/AllChatList.vue'
    import { useChatStore } from '@/stores/chat'
    const chatStore=useChatStore()
    const props = defineProps({
        one: {
            type:Boolean,
            default: false
        },
        productId: {
            type: Number,
            default: 0
        },
        userId: {
            type: Number,
            default: 0
        }
    })
    const showOne = computed(() => {
        return props.one
    })
    const changeType=ref(false)
    const typeChat= ref('none');
    const watchHandlerMain=async (userType,val)=>{
        if(changeType.value) {
            changeType.value=false
            chatStore.resetList()
        }
        let v = parseInt(val) 
        if(v > 0){
            showOne.value = true
            if(showOne.value) {
                if(userType){
                    if(typeChat.value === 'none' || typeChat.value === 'product'){
                        typeChat.value = 'user'
                        changeType.value = true
                        return watchHandlerMain(true,v)
                    }
                    if(chatStore.userSelectedId!==v) {
                        chatStore.resetChatInfo()
                        chatStore.resetList()
                    }
                    chatStore.setUserSelected(v)
                }else{
                    if(typeChat.value === 'none' || typeChat.value === 'user'){
                        typeChat.value = 'product'
                        changeType.value = true
                        return watchHandlerMain(false,v)
                    }
                    if(chatStore.productSelectedId!==v) {
                        chatStore.resetChatInfo()
                        chatStore.resetList()
                    }
                    chatStore.setProductSelected(v)
                }
                await chatStore.getChatInfo()
            }
        }else{
            console.log(val);
        }
    }
    const productId = computed(() => {
        if(props.productId>0){
            watchHandlerMain(false,props.productId)
        }
        return props.productId
    })
    const userId = computed(() => {
        if(props.userId>0){
            watchHandlerMain(true,props.userId)
        }
        return props.userId
    })
</script>
<style scoped>
    .chat-wrapper {
        background-color: #d3d3d34a;
        border-radius: 7px;
        height: 100%;
        box-shadow: 0 0 7px lightgrey;
        display: flex;
        /* height: calc(100vh - 100px); */
        overflow: hidden;
        flex-direction: row-reverse;
        flex-wrap: wrap;
        align-items: stretch;
        justify-content: space-evenly;
        align-content: flex-start;
    }
    .all-users,.all-products{
        width: 50%;
        height: 100%;
        overflow: auto;
    }
    .show-one-user,.show-one-product{
        width: 35%;
        height: 100%;
        overflow: auto;
    }
    .hide,.products,.users,.chats{
        display: none !important;
    }
    .show-one-chat {
        width: 65%;
    }
    .loading{
        background: rgb(16, 16, 143);
    }
    .alert {
        background: #800c0c;
    }
    .loading,.alert {
        text-align: center;
        padding: 20px;
        color: #fff;
        font-size: 20px;
        border-radius: 10px;
        box-shadow: 0 0 10px grey;
        font-weight: 700;
    }
    /* @media screen and (max-width : 500px) {
        .chat-wrapper{
            height: calc(100vh - 140px);
        }
    } */
</style>